import { createContext } from 'react';

import {
  PortfolioOptimizeDashboard,
  ProgramSummary,
} from '@totem/components/services/optimize/v2/dashboard/types';

interface Context {
  buildingId?: string;
  dashboard: PortfolioOptimizeDashboard;
  loading: boolean;
  selectedProgram: ProgramSummary | null;
  setSelectedProgram: (program: ProgramSummary | null) => void;
  requestRefresh: () => void;
}

const emptyDashboard: PortfolioOptimizeDashboard = {
  totalEnergyCostSavings: 0,
  totalDemandCostSavings: 0,
  totalCostSavings: 0,
  totalKwhSaved: 0,
  totalPeakKwReduced: 0,
  programs: [],
};

const defaultContext: Context = {
  buildingId: undefined,
  dashboard: emptyDashboard,
  loading: false,
  selectedProgram: null,
  setSelectedProgram: () => {},
  requestRefresh: () => {},
};

const PortfolioContext = createContext<Context>(defaultContext);

export default PortfolioContext;
